import React from 'react';
import { Badge } from 'react-bootstrap';
import UtilityService from '../services/UtillityServices/UtilityService';

const useRendicontazioneSuperpartnerAdminConfigTable = () => {
    // La funzione per i badge va copiata qui se non è già globale
    const getStatoBadge = (stato) => {
        switch (stato) {
            case 'Liquidato': return <Badge bg="success">Liquidato</Badge>;
            case 'Da Liquidare': return <Badge bg="primary">Da Liquidare</Badge>;
            case 'Verifica Amministrativa': return <Badge bg="warning" text="dark">Verifica Amministrativa</Badge>;
            case 'Liquidazione Sospesa': return <Badge bg="danger">Sospesa</Badge>;
            default: return <Badge bg="secondary">{stato}</Badge>;
        }
    };

    const columns = [
        // CORREZIONE: 'accessorKey' -> 'key', 'header' -> 'label'
        { key: 'nome_superpartner', label: 'Superpartner' },
        { key: 'mese', label: 'Mese' },
        { key: 'anno', label: 'Anno' },
        { 
            key: 'totale_provvigioni', 
            label: 'Totale Provvigioni',
            formatter: (value) => `€ ${parseFloat(value).toFixed(2)}`
        },
        { 
            key: 'stato', 
            label: 'Stato',
            formatter: (value) => getStatoBadge(value)
        },
        {
            key: 'path_fattura',
            label: 'Fattura',
            formatter: (value) => <a href={value} target="_blank" rel="noopener noreferrer">Scarica</a>
        },
        { 
            key: 'data_aggiornamento', 
            label: 'Ultimo Aggiornamento',
            formatter: (value) => UtilityService.formatDate(value)
        }
    ];

    return columns;
};

export default useRendicontazioneSuperpartnerAdminConfigTable;